import { TMentionUser } from '@onesource/schemas';
import axios from '../axios';

interface FetchMentionUsersOptions {
  instructorsOnly?: boolean;
}

export const fetchMentionUsers = async (
  query: string,
  options: FetchMentionUsersOptions = {},
): Promise<TMentionUser[]> => {
  const params: Record<string, string> = { q: query };
  if (options.instructorsOnly) {
    params.instructorsOnly = 'true';
  }

  const res = await axios.get<TMentionUser[]>('/mention/users', { params });

  return res.data;
};

export const fetchInstructorMentionUsers = (query: string): Promise<TMentionUser[]> => {
  return fetchMentionUsers(query, { instructorsOnly: true });
};
